module.exports = "https://static.wanderu.com/ui-react/_next/static/media/auto-grey.1ffeaf98.svg";